import { ModifierOptionPriceType, RecordStatus } from './enums.types';
import { Option } from '../category/category.types';
import { IModifierOption } from './modifierOption.types';

export interface ModifierI {
  id?: number;
  modifierName: string;
  posDisplayName: string;
  parentModifierId?: number;
  isNested: boolean;
  isOptional: boolean;
  canGuestSelectMoreModifiers: boolean;
  multiSelect: boolean;
  minSelector?: number;
  maxSelector?: number;
  limit?: number;
  noMaxSelection: boolean;
  prefix?: string;
  price?: number;
  pizzaSelection: boolean;
  status?: RecordStatus;
  onPrem?: boolean;
  offPrem?: boolean;
  showOnPos?: boolean;
  showOnKiosk?: boolean;
  showOnMpos?: boolean;
  showOnQR?: boolean;
  showOnline?: boolean;
  showOnThirdParty?: boolean;
  showOnNugget?: boolean;
  showOnWebsite?: boolean;
  showOnMenuBoard?: boolean;
  showOnCatering?: boolean;
  isSizeModifier?: boolean;
  limitIndividualModifierSelection: boolean;
  stockStatus: boolean;
  addNested: boolean;
  modifierOptionPriceType: ModifierOptionPriceType;
  createdAt?: Date;
  updatedAt?: Date;
  restaurantId: number;
  updatedBy?: string;
  modType?: ModType;
}

export interface modifierRequestType {
  modifierName: string;
  isOptional: boolean;
  limit: number;
  price: number;
  modifierGroupId?: number;
  multiSelect?: boolean;
  isGeneric?: boolean;
  stockStatus?: boolean;
}

export interface modifierResponseType {
  data: modifierData;
  message: string;
  error?: string | null;
  success?: boolean;
}
export interface IModifierOptionField {
  id?: number | null;
  optionName: string | undefined;
  price?: number | null;
  maxLimit: number | undefined;
  optionDisplayName?: string;
  isDefaultSelected: boolean;
  sortOrder?: number;
}

export interface modifierData {
  id: number;
  modifierName: string;
  isOptional: boolean;
  limit: number;
  price: number;
  showOnMenu: boolean;
  stockStatus: boolean;
  createdAt: Date;
  updatedAt: Date;
  modifierGroupId?: number;
  multiSelect?: boolean;
  isGeneric: boolean;
  subgroups?: modifierData[];
}

export interface ModifierListResponseType {
  data: ModifierI;
  message: string;
  error?: string | null;
}

export interface ModifierItemResponseType {
  data: ModifierI;
  message: string;
  error?: string | null;
}

export interface IModifierResponse {
  modifiers: ModifierI[];
  totalCount: number;
}

export interface IModifierItemResponse {
  modifier: ModifierI;
  parentModifierGroups: string[];
  modifierOptions: IModifierOptionField[];
  nestedModifiers: Option[];
  OptionId: number;
  modifierSelectionCheck?: boolean;
}
export interface ModifierModifierOption {
  modifierId?: number;
  modifierOptionId: number;
  isDefaultSelected: boolean;
  maxLimit?: number;
  modifierOption: IModifierOption;
}

export interface IModifierModifierOption {
  id?: number;
  modifierId: number;
  modifierOptionId: number;
  isDefaultSelected: boolean;
  maxLimit?: number | undefined;
  optionDisplayName?: string;
  sortOrder?: number;
}

export type ModifierFilter = Partial<ModifierI>;

export enum ModType {
  REQUIRED = 'Required',
  OPTIONAL = 'Optional',
  PUSH_OPTIONAL = 'Push Optional',
}
